// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Xl-z","tupacHeader":"Yl-z","tupacHeader2":"Zl-z","tupacMenu":"_l-z","tupacMenu2":"am-z","tupacMain":"bm-z","tupacMain2":"cm-z"};